module.exports = "fonts/Ekster-Bold.otf";